import type { APIMethodParams } from '@medizzy/api';
import z from 'zod';

const requestOTPSchema = z.object({
  email: z.string().email(),
});

export function requestOTP({
  client,
  params,
}: APIMethodParams<z.infer<typeof requestOTPSchema>>) {
  return client
    .url('/auth/otp/request')
    .post(requestOTPSchema.parse(params))
    .res();
}
